"use strict";

import $ from 'jquery'
import 'url-search-params-polyfill'; // Edge Polyfill
import 'whatwg-fetch'; // IE10 Polyfill
import {createAjaxForm} from '@elements/ajax-form';
import fetch from '@elements/fetch';
import formDataEntries from 'form-data-entries';

const defaultSelectors = {
    base: '.js-ajax-form-map',
    result: '.js-ajax-form-map__result',
    loading: '.js-ajax-form-map__loading',
    notifications: '.js-ajax-form-map__notifications',
    form: '.js-ajax-form-map__form',
    additionalForm: '.js-ajax-form-map__additional-form',
    errorArea: '.js-ajax-form-map__error-area',
    retry: '.js-ajax-form-map__retry',
    link: '.js-ajax-form-map__link'
};

export const createInitAjaxFormMap =({initMap, setMarker, activateMarker, setDefaultMarkerStyle, showInfoBoxByMarker}) => {
    return function ($form, selectors = defaultSelectors, options) {

        let formApi = createAjaxForm($form, selectors);

        let formObj = {
            mapObj: initMap(options),
            element: $form,
            formApi: createAjaxForm($form, selectors, {
                onSubmit: x => fetchPois()
            })
        };

        fetchPois();

        function fetchPois() {
            fetch($(formObj.element).data('form-map-url'), {
                method: 'GET',
                headers: {
                    ajax: 1 // add ajax header to differentiate between and ajax requests and page request.
                    // If this header is not set, browser back could lead the browser to use the cached result of this request as page response.
                },
                body: new URLSearchParams(formDataEntries($form.find('form')[0]))
            }).then((res) => {
                return res.json()
            }).then((res) => {
                if (res.success) {
                    setMarker(formObj.mapObj, res.pois);
                }
            }).catch((error) => {
                console.error("loading data-form-map-url failed:" + error);
            });
        }

        return formObj;
    }
};